import React from 'react';
export function RedoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14 11v4l6-5-6-5v4h-1a9 9 0 00-9 9h2a7 7 0 017-7h1z"
  }));
}